import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CAMPAIGN } from "@/constants/testIds";
import { Leaf, CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import { RootsMark } from "@/components/RootsMark";

const LIME = "#B7E64B";

export default function CampaignUnsubscribePage() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | done | error

  useEffect(() => {
    api.post(`/campaign/unsubscribe/${token}`).then(() => setState("done")).catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F5F7F2]" data-testid={CAMPAIGN.unsubscribe}>
      <header className="bg-[#09292D] text-white">
        <div className="mx-auto flex max-w-[1160px] items-center gap-2 px-5 py-4">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg" style={{ backgroundColor: LIME }}>
            <RootsMark className="h-5 w-5 text-[#09292D]" />
          </div>
          <p className="font-heading text-lg font-bold">LIAS<span style={{ color: LIME }}>ROOTS</span></p>
        </div>
      </header>
      <div className="mx-auto max-w-[560px] px-5 py-16">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
          {state === "loading" && <Loader2 className="mx-auto h-10 w-10 animate-spin text-[#4e8a1f]" />}
          {state === "done" && (
            <>
              <CheckCircle2 className="mx-auto h-12 w-12 text-[#4e8a1f]" />
              <h1 className="mt-3 font-heading text-2xl font-bold text-[#09292D]">You've been unsubscribed</h1>
              <p className="mt-2 text-sm text-slate-600">You won't receive further marketing emails about the LIASROOTS pilot. This doesn't affect any active enquiry — we may still contact you about it.</p>
            </>
          )}
          {state === "error" && (
            <>
              <AlertCircle className="mx-auto h-12 w-12 text-rose-500" />
              <h1 className="mt-3 font-heading text-2xl font-bold text-[#09292D]">This link is no longer valid</h1>
              <p className="mt-2 text-sm text-slate-600">We couldn't process this unsubscribe request. The link may have expired.</p>
            </>
          )}
          <Link to="/liasroots" className="mt-5 inline-block text-sm font-semibold text-[#09292D] underline">Back to the pilot page</Link>
        </div>
      </div>
    </div>
  );
}
